<template>
  <div class="box">
    <div class="contentRight">
      <div class="contentRight_title">
        <div class="contentRight_title_from">
          <Form
            ref="formValidate"
            :model="formValidate"
            :label-width="80"
            class="form-container"
          >
            <FormItem label="设备数据" prop="city" v-if="chansAll.length > 1">
              <Select
                v-model="formValidate.city"
                placeholder="请选择"
                style="width: 150px"
              >
                <Option v-for="chans in chansAll" :key="chans" :value="chans">
                  {{ chans }}
                </Option>
              </Select>
            </FormItem>
            <FormItem :label="$t('时间')" prop="date">
              <DatePicker
                v-model="formValidate.date"
                type="datetimerange"
                :placeholder="$t('请选择')"
                style="width: 320px"
              />
            </FormItem>
            <div class="youshang">
              <div>
                <Button
                  type="primary"
                  style="marginright: 10px"
                  @click="queryData"
                  >{{ $t("查询") }}</Button
                >
                <Button style="marginright: 10px" @click="todayData">{{
                  $t("返回今日")
                }}</Button>
              </div>
            </div>
          </Form>
          <div class="contentRight_title_export">
            <div class="export-item" @click="exportHistory">
              <img src="./images/export.png" alt="" />
              <p>{{ $t("数据导出") }}</p>
            </div>
            <!-- <div class="export-item" @click="tiaozhuan">
                                  <img src="./images/look.png" alt="" />
                                  <p>历史数据详情</p>
                                </div> -->
          </div>
        </div>
      </div>
      <div class="echarsView2">
        <echarsView2
          :mosState="mosState"
          :timestampsLine="timestampsLine"
          :dianliuLine="dianliuLine"
          :dianliuLine1="dianliuLine1"
          :shengyurongliangLine="shengyurongliangLine"
          :zongdianyaDataLine="zongdianyaDataLine"
          :chongdianDataLine="chongdianDataLine"
          :fangdianDataLine="fangdianDataLine"
          :yachaLine="yachaLine"
          :moswendu="moswendu"
          :huanjingwendu="huanjingwendu"
          :NTC4="NTC4"
          :NTC3="NTC3"
          :NTC2="NTC2"
          :NTC1="NTC1"
        />
      </div>
      <!-- <div style="text-align: center;margin-bottom: 10px;">
                      <Page
                        :total="40"
                        size="small"
                        show-elevator
                        show-sizer
                        show-total
                      />
                    </div> -->
    </div>
  </div>
</template>
<script>
import packageTableMixins from "@/mixins/packageTableMixins";
import logoImg1 from "./images/dianchi1.png";
import logoImg2 from "./images/dianchi2.png";
import logoImg3 from "./images/dianchi3.png";
import DistributionLog from "../devicedistribution/distributionLog1";
import Control from "../control/control.vue";
import Historyrouter from "../historyrouter/historyrouter";
import echarsView2 from "../details/echarsView2.vue";
import AlermDes from "../../alarmManage/alermDes/alermDes2.vue";
import { ChartPie, ChartItemBar, ChartLineStackMul2 } from "_c/charts";
import {
  get_device4g,
  get_left_data4g,
  get_qr_code,
  get_4g_broken_line,
  get_danti_view,
} from "@/api/chuku";
import { get_now_lnglat, get_downloadtoken } from "@/api/jingxiaoshang";
import { commonReq } from "@/api/common";
import * as echarts from "echarts";
export default {
  name: "MechanismManage",
  mixins: [packageTableMixins],
  data() {
    const now = new Date();
    const startOfDay = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      0,
      0,
      0
    );
    const endOfDay = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      23,
      59,
      59
    );

    return {
      mosState: null,
      voltage_listRight: null,
      highestRight: null,
      minimumRight: null,
      yachaRight: null,
      averageRight: null,
      timestampsLine: null,
      dianliuLine: null,
      dianliuLine1: null,
      shengyurongliangLine: null,
      yachaLine: null,
      zongdianyaDataLine: null,
      moswendu: null,
      chongdianDataLine: null,
      project_id: null,
      pack_sn: null,
      xunhuan_num: null,
      dianchichuan: null,
      mos_wendu: null,
      now_connect_status: null,
      huanjing_wendu: null,
      chongdianmos: null,
      junheng: null,
      fangdianmos: null,
      now_connect_status: null,
      fangdianDataLine: null,
      huanjingwendu: null,
      NTC4: null,
      NTC3: null,
      NTC2: null,
      NTC1: null,
      zongdianya: null,
      dianliu: null,
      gonglv: null,
      manchong_capacity: null,
      remaining_capacity: null,
      battery_status: null,
      qr_url: null,
      soc: null,
      hardware_verAll: null,
      hardware_ver: null,
      pack_sn: null,
      chans: null,
      chansAll: null,
      did: null,
      sn: null,
      values: [], // 示例数据
      formValidate: {
        city: "",
        date: [startOfDay, endOfDay],
      },
      gaugeChart: null,
      currDidTab: "0",
      details_data: [
        "实时监测预览",
        "参数设置",
        "历史记录",
        "告警数据",
        "历史轨迹",
        "密码管理",
      ],
      items: [
        {
          icon: "./images/lingdang.png",
          label: "单体过压",
          linkIcon: "./images/tiaozhuan.png",
          color: "rgba(237, 64, 20, 1)",
        },
        {
          icon: "./images/lingdang.png",
          label: "另一个状态",
          linkIcon: "./images/tiaozhuan.png",
          color: "rgba(20, 64, 237, 1)",
        },
      ],
    };
  },
  components: {
    ChartPie,
    ChartItemBar,
    ChartLineStackMul2,
    DistributionLog,
    AlermDes,
    Control,
    Historyrouter,
    echarsView2,
  },
  methods: {
    change_tab2(tab) {
      this.currDidTab = tab;
    },
    //背景
    getDianchiStyle(value) {
      const maxValue = Math.max(...this.values);
      const minValue = Math.min(...this.values);

      if (value == maxValue) {
        return {
          backgroundImage: `url(${logoImg3})`, // 最大值背景
        };
      } else if (value == minValue) {
        return {
          backgroundImage: `url(${logoImg2})`, // 最小值背景
        };
      } else {
        return {
          backgroundImage: `url(${logoImg1})`, // 其他值背景
        };
      }
    },
    //折线图
    convertLine(value) {
      this.timestampsLine = value.map((item) => item.timestamp);
      // this.dianliuLine = value.map((item) => Number(item.dianliu));
      this.dianliuLine = value.map((item) => {
        const dianliuValue = Number(item.dianliu);
        return dianliuValue < 0 ? 0 : dianliuValue;
      });
      this.dianliuLine1 = value.map((item) => {
        const dianliuValue = Number(item.dianliu);
        return dianliuValue > 0 ? 0 : Math.abs(dianliuValue);
      });
      this.shengyurongliangLine = value.map((item) => Number(item.soc));
      this.yachaLine = value.map((item) => Number(item.yacha));
      console.log("折线图数据", this.yachaLine);
      this.zongdianyaDataLine = value.map((item) => Number(item.zongdianya));
      this.chongdianDataLine = value.map((item) => Number(item.chongdianmos));
      this.fangdianDataLine = value.map((item) => Number(item.fangdianmos));
      this.moswendu = value.map((item) => Number(item.mos_wendu));
      this.huanjingwendu = value.map((item) => Number(item.huanjing_wendu));
      this.NTC1 = value.map((item) => Number(item.NTC1));
      this.NTC2 = value.map((item) => Number(item.NTC2));
      this.NTC3 = value.map((item) => Number(item.NTC3));
      this.NTC4 = value.map((item) => Number(item.NTC4));
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    //查询
    queryData() {
      this.formValidate.date[0] = this.formatDate(this.formValidate.date[0]);
      this.formValidate.date[1] = this.formatDate(this.formValidate.date[1]);
      console.log("查询", this.formValidate);
      get_4g_broken_line({
        did: this.did,
        chan: this.formValidate.city,
        start_time: this.formValidate.date[0],
        end_time: this.formValidate.date[1],
      }).then((res) => {
        this.mosState = res.body.mos;
        this.convertLine(res.body.yunxing_trends);
      });
    },
    todayData() {
      const now = new Date();
      let startOfDay = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        0,
        0,
        0
      );
      let endOfDay = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        23,
        59,
        59
      );
      this.formValidate.date = [
        this.formatDate(startOfDay),
        this.formatDate(endOfDay),
      ];
      get_4g_broken_line({
        did: this.did,
        chan: this.formValidate.city,
        start_time: this.formValidate.date[0],
        end_time: this.formValidate.date[1],
      }).then((res) => {
        this.mosState = res.body.mos;
        this.convertLine(res.body.yunxing_trends);
      });
    },
    //导出
    exportHistory() {
      this.formValidate.date[0] = new Date(this.formValidate.date[0]).getTime();
      this.formValidate.date[1] = new Date(this.formValidate.date[1]).getTime();
      get_downloadtoken({ type: "1" }).then((res) => {
        _this.buttonLoading = false;
        if (res.result === 0) {
          let downloadtoken = res.body.downloadtoken;
          commonReq("/index.php/admin/devicedetail/get_device_type", {
            did: vm.form_filter.did,
          }).then((res) => {
            if (res.result === 0) {
              let lang =
                localStorage.getItem("local") === "en-US" ? "en-us" : "zh-cn";
              commonReq(`/index.php/admin/device/history_daochu?lang=${lang}`, {
                type: 1,
                downloadtoken: downloadtoken,
                did: vm.form_filter.did,
                time_start: formModel.start_time,
                time_end: formModel.end_time,
              }).then((res) => {
                vm.$Message.success(vm.$t("导出成功"));
                vm.$Modal.remove();
                const routeData = vm.$router.push({
                  path: "/deviceman/downloadlist",
                });
                window.open(routeData.href, "_self");
              });

              // }
            }
          });
        } else {
          vm.$Message.error(res.errorMsg);
        }
      });
    },
    tiaozhuan() {
      this.currDidTab = "2";
    },
  },
  mounted() {
    this.did = this.$route.query.did;
    get_device4g({ did: this.did }).then((res) => {
      get_qr_code({ did: this.did }).then((res) => {
        this.qr_url = res.body.qrcode_url;
      });
      this.chansAll = res.body.chans;
      this.chans = res.body.chans[0];
      this.formValidate.city = res.body.chans[0];
      get_4g_broken_line({
        did: this.did,
        chan: this.formValidate.city,
        start_time: this.formatDate(this.formValidate.date[0]),
        end_time: this.formatDate(this.formValidate.date[1]),
      }).then((res) => {
        this.mosState = res.body.mos;
        this.convertLine(res.body.yunxing_trends);
      });
    });
  },
  destroyed() {},
};
</script>
<style scoped>
.box {
  overflow: auto;
  background: white;
}
.content {
  display: flex;
}
.contentLeft {
  width: 520px;
  margin-right: 12px;
  background: white;
  padding: 20px;
}
.contentLeft_top_title {
  display: flex;
}
.contentLeft_top_title div {
  width: 50%;
  color: rgba(105, 109, 115, 1);
  font-size: 14px;
  font-weight: 400;
}
.contentLeft_top_value {
  display: flex;
  color: rgba(53, 55, 57, 1);
  font-size: 14px;
  font-weight: 600;
}
.contentLeft_top_value div:nth-child(1) {
  width: 53%;
  flex-wrap: nowrap;
}
.contentLeft_top_value div span {
  display: inline-block;
  margin-left: 5px;
  cursor: pointer;
}
.contentLeft_top_title div:nth-child(2) {
  margin-left: 30px;
}
.contentLeft_top_title {
  margin-top: 10px;
}
.echarts_content {
  display: flex;
  margin-top: 40px;
  justify-content: space-between;
}
.echarts_content_left {
  line-height: 50%;
  font-size: 14px;
  width: 150px;
  white-space: nowrap; /* 不换行 */
  overflow: hidden; /* 隐藏超出部分 */
  text-overflow: ellipsis; /* 省略号 */
}
.item {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  cursor: pointer;
}
.echarts_content_left div img {
  width: 16px;
}
.echarts_content_left div:nth-child(1) {
  margin-right: 5px;
}
.echarts_content_center {
  margin-left: -140px;
}
.dainchi {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.dainchi div {
  margin-right: 30px;
}
.dainchi div p {
  text-align: center;
}
.dainchi div p:nth-child(2) {
  color: rgba(53, 55, 57, 1);
  font-weight: 600;
}
.dianchibj {
  /* background: rgba(242, 243, 246, 1); */
  /* border-radius: 6px;
  padding: 2px; */
  /* margin: auto; */
}
.fenkai {
  height: 30px;
  margin-top: 5px;
  border-right: 1px solid rgba(216, 216, 216, 1);
}
.dianya {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
  width: 480px;
  margin-right: auto;
  border: 1px solid rgba(225, 230, 234, 1);
  border-radius: 6px;
  padding: 10px 0;
}
.dianya div p {
  display: flex;
  align-items: center;
  justify-content: center;
}
.dianya div p:nth-child(2) {
  color: rgba(53, 55, 57, 1);
  font-weight: 700;
  font-size: 16px;
}
.information {
  display: flex;
  margin-top: 20px;
}
.information_left {
  width: 180px;
  border-right: 1px solid rgba(216, 216, 216, 1);
}
.information_left div {
  display: flex;
  align-items: center;
  margin-top: 5px;
}
.information_left div p:nth-child(2) {
  margin-left: 10px;
}
.information_left div p:nth-child(1) {
  width: 100px;
}
.information_right {
  margin-left: 20px;
  font-size: 14px;
}
.information_right div p:nth-child(1) {
  width: 110px;
}
.information_right div {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
/* .information_right div:nth-child(5) {
  margin-top: 8px;
}
.information_right div:nth-child(6) {
  margin-top: 6px;
}
.information_right div:nth-child(7) {
  margin-top: 6px;
} */
.mapcontent {
  position: relative;
}
.map {
  width: 478px;
  height: 403px;
  margin: auto;
  margin-top: 20px;
}
.lookmap img {
  width: 88px;
  height: 26px;
  position: absolute;
  right: 5px;
  top: 5px;
}
.contentRight {
  width: 100%;
  background: white;
}
.echarsView2 {
  width: 100%;
}
.contentRight_footer_right_btn {
  width: 100%;
  padding-right: 150px;
}
.contentRight_title {
  position: relative;
  padding-top: 12px;
}
.contentRight_title_from {
  position: relative;
}
.contentRight_title_export {
  display: flex;
  align-items: center;
  justify-content: end;
  position: absolute;
  right: 5px;
  top: 5px;
}
.contentRight_title_export p {
  color: rgba(45, 140, 240, 1);
  font-size: 16px;
}
.contentRight_title_export {
  display: flex;
  flex-direction: row;
}
.form-container {
  display: flex;
  flex-wrap: wrap; /* 允许换行 */
  align-items: center; /* 垂直居中对齐 */
  gap: 10px; /* 元素间距 */
}
.export-item {
  display: flex;
  align-items: center; /* 垂直居中对齐 */
  margin-right: 10px; /* 每项之间的间距 */
  cursor: pointer;
}

.export-item img {
  margin-right: 4px; /* 图片与文字之间的间距 */
  width: 16px;
}
.contentRight_footer_content {
  display: flex;
}
.contentRight_footer {
  background: rgba(242, 243, 246, 1);
  padding-top: 12px;
  padding-bottom: 12px;
}
.contentRight_footer_left {
  width: 150px;
}
.contentRight_footer_left div {
  margin-top: 20px;
  margin-left: 16px;
  background: white;
}
.contentRight_footer_left div p:nth-child(1) {
  font-size: 14px;
  color: rgba(105, 109, 115, 1);
}
.contentRight_footer_left div p:nth-child(2) {
  font-size: 16px;
  font-weight: 700;
  color: rgba(53, 55, 57, 1);
}

.contentRight_footer_title {
  padding: 12px;
  color: rgba(53, 55, 57, 1);
  font-size: 14px;
  font-weight: 600;
  border-bottom: 1px solid rgba(225, 230, 234, 1);
}
.dianchi {
  width: 90px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  background-size: cover; /* 使背景图像覆盖整个 div */
  background-position: center; /* 居中显示背景图像 */
}
.dianchivalue {
  width: 90px;
  text-align: center;
}
.contentRight_footer_right {
  margin-left: 5px;
  width: 80%;
}
.contentRight_footer_right_top {
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  height: 120px;
  overflow-y: auto;
}
.contentRight_footer_right_top div {
  margin-right: 10px;
  margin-top: 5px;
}
.youshang {
  display: flex;
  align-items: center;
  margin-top: -22px;
}
</style>
